import { useContext } from 'react'
import { Context } from '../contexts/CvipProvider'

const useCvip = () => {
  const { cvip } = useContext(Context)
  return cvip
}

export default useCvip
